import type { ColumnDef } from "@tanstack/react-table";
import { ServiceTitanIconLink } from "@/core/components/service-titan-icon-link";
import { Stack } from "@/core/components/ui/stack";
import { ConfidenceLabel } from "@/accounts-payable/common";
import type { ApReceipt } from "@/accounts-payable/types";
import { stJobUrl } from "@/accounts-payable/utils";

export const jobCol: ColumnDef<ApReceipt> = {
  id: "job",
  header: "Matched job",
  meta: { size: "150px" },
  cell: ({ row }) => {
    const { st_job_external_id, job_match_confidence } = row.original;
    if (!st_job_external_id)
      return <span className="text-tertiary-text">—</span>;
    return (
      <Stack gap="xs" align="start">
        <ServiceTitanIconLink
          url={stJobUrl(st_job_external_id)}
          label={`Open job #${st_job_external_id} in ServiceTitan`}
          stopPropagation
          className="ml-0 text-interactive-text hover:text-interactive-text hover:underline"
        >
          #{st_job_external_id}
        </ServiceTitanIconLink>
        {job_match_confidence != null && (
          <ConfidenceLabel value={job_match_confidence} />
        )}
      </Stack>
    );
  },
};
